package com.artvending.warden.screens

import androidx.compose.runtime.Composable
import com.artvending.warden.Alignment
import com.artvending.warden.Column
import com.artvending.warden.Column_
import com.artvending.warden.ContainerScope
import com.artvending.warden.Image
import com.artvending.warden.Overflow
import com.artvending.warden.Page
import com.artvending.warden.Row
import com.artvending.warden.Row_
import com.artvending.warden.RowScope
import com.artvending.warden.Scaffold
import com.artvending.warden.Text_
import com.artvending.warden.avatar
import com.artvending.warden.confirm
import com.artvending.warden.currentPage
import com.artvending.warden.currentScreenModel
import com.artvending.warden.dialog
import com.artvending.warden.errorMessage
import com.artvending.warden.settings
import com.artvending.warden.language
import com.artvending.warden.log
import com.artvending.warden.myOnClick
import com.artvending.warden.reloadPage
import com.artvending.warden.screens.history.HistoryScreenModel
import com.artvending.warden.screens.home.HomeScreenModel
import com.artvending.warden.screens.scanner.ScannerScreenModel
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.attributes.Draggable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*


@Composable
fun MenuButton(title: String, iconName: String, isMain: Boolean = false, isSelected: Boolean = false, onClick: () -> Unit) {
	Button({
		classes("menu-button", "ripple-button")
		style {
			flexGrow(1); height(80.px); borderRadius(settings.space)
		}
		onClick { onClick() }
		//myOnClick { onClick() }
	}) {
		Column_({ style { gap(settings.smallSpace / 2) } }) {
			Column_({ style { if (isSelected) backgroundColor(settings.secondaryContainerColor); alignSelf(AlignSelf.Center); height((if (isMain) 56 else 32).px); width((if (isMain) 56 else 64).px); borderRadius(100.px) } }) {
				Img(iconName + if (isSelected) "_active.svg" else ".svg") { draggable(Draggable.False); style { height((if (isMain) 48 else 24).px); width((if (isMain) 48 else 24).px); flexGrow(1); alignSelf(AlignSelf.Center) } }
			}
			
			if (!isMain)
				Div({ classes(settings.labelFontClass); style { property("color", "#1D1B20"); fontWeight(if (isSelected) 700 else 500) } }) {
					Text(title)
				}
		}
	}
}


@Composable
fun ContainerScope.MenuButton(title: String, iconName: String, isMain: Boolean = false, isSelected: Boolean = false, onclick: () -> Unit) {
//	Button_(
//		if (isMain) null else title,
//		image = iconName + if (isSelected) "_active.svg" else ".svg",
//		imageSize = (if (isMain) 48 else 24).px,
//		imagePlace = RelativePlace.top,
//		height = 80.px,
//		cornerRadius = settings.space,
//		clickByTouch = isSensor,
//		classes = "menu-button ripple-button",
//		weight = 1,
//	) {
//		onclick()
//	}
	
	Button({
		classes("menu-button", "ripple-button")
		style {
			flexGrow(1); height(80.px); borderRadius(settings.space)
		}
		myOnClick { onclick() }
	}) {
		Column_({ style { gap(settings.smallSpace / 2) } }) {
			Column_({ style { if (isSelected) backgroundColor(settings.secondaryContainerColor); alignSelf(AlignSelf.Center); height((if (isMain) 56 else 32).px); width((if (isMain) 56 else 64).px); borderRadius(100.px) } }) {
				Img(iconName + if (isSelected) "_active.svg" else ".svg") { draggable(Draggable.False); style { height((if (isMain) 48 else 24).px); width((if (isMain) 48 else 24).px); flexGrow(1); alignSelf(AlignSelf.Center) } }
			}
			
			if (!isMain)
				Div({ classes(settings.labelFontClass); style { property("color", "#1D1B20"); fontWeight(if (isSelected) 700 else 500) } }) {
					Text_(title)
				}
		}
	}
}


@Composable
fun ContainerScope.MainContent() {
	Scaffold(padding = settings.space, weight = 1, overflow = Overflow.autoScroll) {
		top {
			Column(space = settings.space) {
				Scaffold(space = settings.space) {
					left {
						Row(space = settings.space) {
							Image(
								"logo-3.png", height = 48.px, onClick = {
									if (confirm(language.UPDATE_PAGE_QUESTION))
										reloadPage()
								}
							)
							Text_("Warden", classes = settings.titleFontClass, alignment = Alignment.center)
						}
					}
					right {
						Row(space = settings.space) {
							Text_(text = "v. ${settings.VERSION}", classes = settings.labelFontClass, color = settings.opacityGray, alignment = if (avatar == "") null else Alignment.center)
							
							if (avatar != "")
								Image(avatar, "avatar", alignment = Alignment.center, height = 48.px, cornerRadius = 100.px)
						}
					}
				}
				
				Column(marginHorizontal = -settings.space, space = 1.px) {
					if (settings.DEBUG_MODE)
						Text_(language.TEST_MODE, padding = settings.smallSpace, classes = settings.labelFontClass, color = Color.white, backgroundColor = Color.purple)
					
					if (errorMessage != "")
						Text_(errorMessage, padding = settings.smallSpace, classes = settings.labelFontClass, color = Color.white, backgroundColor = rgb(128, 0, 0))
				}
			}
		}
		center {
			currentScreenModel?.Display(RowScope())
		}
	}
}


@Composable
fun ContainerScope.BottomMenu() {
	Row {
		MenuButton(language.HOME, "home", false, currentPage == Page.HOME) { currentScreenModel = HomeScreenModel() }
		MenuButton(language.SCANNER, "scanner", true, currentPage == Page.SCANNER) { currentScreenModel = ScannerScreenModel() }
		MenuButton(language.HISTORY, "history", false, currentPage == Page.HISTORY) { currentScreenModel = HistoryScreenModel() }
	}
}


@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun ContainerScope.PageScreen_() {
//	Scaffold(
//		vAlignment = Alignment.stretch, overflow = Overflow.hidden,
////		style = {
////			transform {
////				scale(scale)
////				property("transform-origin", "top left")
////			}
////		}
//	) {
//		center {
//			MainContent()
//		}
//		bottom {
//			BottomMenu()
//		}
//	}
	
	Column(vAlignment = Alignment.stretch, overflow = Overflow.hidden, weight = 1) {
		MainContent()
		BottomMenu()
	}
	
	dialog.Display()
}


@OptIn(ExperimentalComposeWebApi::class)
@Composable
actual fun PageScreen() {
	Column_({
		classes(settings.bodyFontClass)
		style {
			flexGrow(1)
			overflow("hidden")
			//width((100 / scale).vw)
			//height((100 / scale).vh)
			//property("transform-origin", "top left")
			//transform { scale(scale) }
			//border(3.px,LineStyle.Solid, Color.green)
		}
	}) {
		log("PageScreen()--------------")
		Column_({ style { gap(settings.space); padding(settings.space); flexGrow(1); overflow("auto") } }) {
			Row_({ style { gap(settings.space); overflow("visible") } }) {
				Img("logo-3.png", "logo") {
					draggable(Draggable.False);
					onClick {
						if (confirm(language.UPDATE_PAGE_QUESTION))
							reloadPage()
					}
					style { height(48.px) }
				}
				Div({ style { flexGrow(1) } })
				Div({ classes(settings.labelFontClass); style { color(settings.opacityGray); if (avatar != "") alignSelf(AlignSelf.Center) } }) {
					Text("v. ${settings.VERSION}")
				}
				
				if (avatar != "")
					Img(avatar, "avatar") { draggable(Draggable.False); style { alignSelf(AlignSelf.Center); height(48.px); borderRadius(100.px) } }
			}
			
			if (settings.DEBUG_MODE)
				Span({ classes(settings.labelFontClass); style { color(Color.white); backgroundColor(Color.purple); alignSelf(AlignSelf.Stretch); fontWeight("bold") } }) {
					Text(language.TEST_MODE)
				}
			
			if (errorMessage != "")
				Span({ classes(settings.labelFontClass); style { color(Color.darkred); } }) {
					Text(errorMessage)
				}
			
			Div({ style { display(DisplayStyle.Flex); flexGrow(1); flexDirection(FlexDirection.Column) } }) {
				currentScreenModel?.Display(null)
			}
		}
		dialog.Display()
		
		Row_({ style {
			//paddingBottom(settings.space)
		} }) {
			MenuButton(language.HOME, "home", false, currentPage == Page.HOME) { currentScreenModel = HomeScreenModel() }
			MenuButton(language.SCANNER, "scanner", true, currentPage == Page.SCANNER) { currentScreenModel = ScannerScreenModel() }
			MenuButton(language.HISTORY, "history", false, currentPage == Page.HISTORY) { currentScreenModel = HistoryScreenModel() }
		}
	}
}